import React from "react";
import { Box, MenuItem } from "@mui/material";
import { SpecsInputField } from "./SpecsInputField";

export function SpecsSelectField({
  label,
  value,
  options,
  onChange,
  sx,
  debugPath,
  clickToEdit,
}: {
  label: React.ReactNode;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
  sx?: React.ComponentProps<typeof Box>["sx"];
  debugPath?: string;
  clickToEdit?: boolean;
}) {
  return (
    <SpecsInputField
      label={label}
      debugPath={debugPath}
      clickToEdit={clickToEdit}
      select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        ...sx,
        "& .MuiInputBase-root": {
          fontSize: 14,
          minHeight: "auto",
          m: 0,
          p: 0,
        },
        "& .MuiSelect-select": {
          py: "7px",
          display: "flex",
          alignItems: "center",
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </SpecsInputField>
  );
}
